import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import { registerQuery, useQuery as useQueryDFC } from 'data-fetching-client';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import useSkipCrm from 'framework-listing-lib/internal/hooks/useSkipCrm';
const GET_PROPERTY_GROUPS_FIELD_NAME = 'listingLibAllPropertyGroups';
const GET_PROPERTY_GROUPS = registerQuery({
  args: ['objectTypeId', 'showHighlySensitiveProperties'],
  fieldName: GET_PROPERTY_GROUPS_FIELD_NAME,
  fetcher({
    objectTypeId,
    showHighlySensitiveProperties
  }) {
    return getFrameworkDataSchemasClient().then(client => client.properties.getGroups({
      frameworkTypeIdentifier: objectTypeId,
      query: {
        showHighlySensitiveProperties: Boolean(showHighlySensitiveProperties)
      }
    }));
  }
});
const GET_OBJECT_TYPES_FIELD_NAME = 'listingLibAllObjectTypes';
const GET_OBJECT_TYPES = registerQuery({
  fieldName: GET_OBJECT_TYPES_FIELD_NAME,
  fetcher() {
    return getFrameworkDataSchemasClient().then(client => client.frameworkTypes.getObjects());
  }
});
export default function useFetchListingLibData(t0) {
  "use memo";

  const $ = _c(31);
  const {
    showHighlySensitiveProperties
  } = t0;
  const objectTypeId = useObjectTypeId();
  const skipCrm = useSkipCrm();
  let t1;
  if ($[0] !== objectTypeId || $[1] !== showHighlySensitiveProperties) {
    t1 = {
      objectTypeId,
      showHighlySensitiveProperties
    };
    $[0] = objectTypeId;
    $[1] = showHighlySensitiveProperties;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] !== objectTypeId) {
    t2 = () => {
      Metrics.counter("fetch-properties-success", {
        object_type_id: objectTypeId
      }).increment();
    };
    t3 = () => {
      Metrics.counter("fetch-properties-failure", {
        object_type_id: objectTypeId
      }).increment();
    };
    $[3] = objectTypeId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== skipCrm || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = {
      variables: t1,
      skip: skipCrm,
      onCompleted: t2,
      onError: t3
    };
    $[6] = skipCrm;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    data: propertyGroupsData,
    loading: propertyGroupsloading,
    error: propertyGroupsError
  } = useQueryDFC(GET_PROPERTY_GROUPS, t4);
  let t5;
  let t6;
  if ($[11] !== objectTypeId) {
    t5 = () => {
      Metrics.counter("fetch-object-types-success", {
        object_type_id: objectTypeId
      }).increment();
    };
    t6 = () => {
      Metrics.counter("fetch-object-types-failure", {
        object_type_id: objectTypeId
      }).increment();
    };
    $[11] = objectTypeId;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  let t7;
  if ($[14] !== skipCrm || $[15] !== t5 || $[16] !== t6) {
    t7 = {
      skip: skipCrm,
      onCompleted: t5,
      onError: t6
    };
    $[14] = skipCrm;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const {
    data: objectTypesData,
    loading: objectTypesloading,
    error: objectTypesError
  } = useQueryDFC(GET_OBJECT_TYPES, t7);
  let t8;
  bb0: {
    if (!propertyGroupsData || !Array.isArray(propertyGroupsData === null || propertyGroupsData === void 0 ? void 0 : propertyGroupsData.listingLibAllPropertyGroups)) {
      let t9;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [];
        $[18] = t9;
      } else {
        t9 = $[18];
      }
      t8 = t9;
      break bb0;
    }
    let t9;
    if ($[19] !== propertyGroupsData.listingLibAllPropertyGroups) {
      t9 = propertyGroupsData.listingLibAllPropertyGroups.map(_temp2);
      $[19] = propertyGroupsData.listingLibAllPropertyGroups;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    t8 = t9;
  }
  const propertyGroups = t8;
  const t9 = propertyGroupsError || objectTypesError;
  const t10 = propertyGroupsloading || objectTypesloading;
  let t11;
  if ($[21] !== propertyGroups) {
    t11 = propertyGroups.map(_temp3).flat().filter(_temp4);
    $[21] = propertyGroups;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== objectTypesData) {
    t12 = objectTypesData !== null && objectTypesData !== void 0 && objectTypesData.listingLibAllObjectTypes && Array.isArray(objectTypesData.listingLibAllObjectTypes) ? objectTypesData.listingLibAllObjectTypes : [];
    $[23] = objectTypesData;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== propertyGroups || $[26] !== t10 || $[27] !== t11 || $[28] !== t12 || $[29] !== t9) {
    t13 = {
      error: t9,
      loading: t10,
      properties: t11,
      propertyGroups,
      typeDefinitions: t12
    };
    $[25] = propertyGroups;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
    $[29] = t9;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp4(property) {
  return property !== undefined;
}
function _temp3(propertyGroup_0) {
  return propertyGroup_0.properties;
}
function _temp2(propertyGroup) {
  return Object.assign({}, propertyGroup, {
    label: propertyGroup.displayName,
    properties: Array.isArray(propertyGroup.propertyDefinitions) ? propertyGroup.propertyDefinitions.map(_temp) : []
  });
}
function _temp(definition) {
  return Object.assign({}, definition.property, {
    fieldType: definition.property.fieldType,
    sensitiveDataCategories: definition.property.sensitiveDataCategories,
    type: definition.property.type
  });
}